import vehicleTypeTranslate from '../utils/vehicleTypeTranslate'
import { formatCurrency, formatWithThousandSep } from '../utils/utils'

export interface VehicleFrameType {
  plate?: string
  type?: string
  brand?: string
  model?: string
  version?: string
  year?: number
  color?: string
  color_format?: string
  odometer?: number
  chassisId?: string
  engineId?: string
  price?: number
}
export const VehicleFrame: React.FC<{ vehicle: VehicleFrameType; noPrice?: boolean }> = ({ vehicle, noPrice }) => {
  const type_format = vehicleTypeTranslate[vehicle.type ?? ''] || (vehicle.type ?? '')
  const odometer_format = formatWithThousandSep(vehicle.odometer ?? 0)
  const price_format = formatCurrency(vehicle.price ?? 0)

  return (
    <section className="border border-gray-400 p-4 print:border-gray-400 print:p-2 mb-4 print:mb-2 print:break-inside-avoid">
      <h5 className="text-xl print:text-sm font-bold uppercase border-b border-gray-300 pb-2 print:border-b-0 print:pb-0 mb-2 print:mb-1 text-gray-700">
        Datos del Vehículo
      </h5>
      <table className="w-full text-base print:text-xs border-separate border-spacing-y-1 print:border-spacing-y-0.5">
        <tbody>
          <tr>
            <td className="w-[12%] text-gray-600 uppercase">Tipo</td>
            <th className="w-[21%] text-left font-bold">{type_format}</th>
            <td className="w-[12%] text-gray-600 uppercase">Marca</td>
            <th className="w-[21%] text-left font-bold">{vehicle.brand}</th>
            <td className="w-[12%] text-gray-600 uppercase">Modelo</td>
            <th className="w-[22%] text-left font-bold">{`${vehicle.model} ${vehicle.version}`}</th>
          </tr>
          <tr>
            <td className="text-gray-600 uppercase">Año</td>
            <th className="text-left font-bold">{vehicle.year}</th>
            <td className="text-gray-600 uppercase">Color</td>
            <th className="text-left font-bold">{vehicle.color_format}</th>
            <td className="text-gray-600 uppercase">Kilometraje</td>
            <th className="text-left font-bold">{odometer_format}</th>
          </tr>
          <tr>
            <td className="text-gray-600 uppercase">Patente</td>
            <th className="text-left font-bold">{vehicle.plate}</th>
            <td className="text-gray-600 uppercase">N° Chassis</td>
            <th className="text-left font-bold" colSpan={3}>
              {vehicle.chassisId}
            </th>
          </tr>
          <tr>
            <td className="text-gray-600 uppercase">N° Motor</td>
            <th className="text-left font-bold" colSpan={3}>
              {vehicle.engineId}
            </th>
            {!noPrice && (
              <>
                <td className="text-gray-600 uppercase font-bold text-black">Precio Lista</td>
                <th className="text-left font-bold text-black">{price_format}</th>
              </>
            )}
          </tr>
        </tbody>
      </table>
    </section>
  )
}
